'use client';

import { BoardType } from '../types';
import Tile from './Tile';
import useSwipe from '../hooks/useSwipe';
import { DirectionType } from '../types';
import { GRID_SIZE } from '../lib/boardUtils';

interface BoardProps {
  board: BoardType;
  onMove: (direction: DirectionType) => void;
}

export default function Board({ board, onMove }: BoardProps) {
  const { handleTouchStart, handleTouchMove, handleTouchEnd } = useSwipe(onMove);

  // Create grid cells (empty cells)
  const renderGridCells = () => {
    return Array.from({ length: GRID_SIZE * GRID_SIZE }).map((_, index) => (
      <div key={`cell-${index}`} className="bg-[#cdc1b4] rounded-md"></div>
    ));
  };

  // Render tiles on top of the grid
  const renderTiles = () => {
    const tiles = [];
    
    for (let y = 0; y < GRID_SIZE; y++) {
      for (let x = 0; x < GRID_SIZE; x++) {
        const tile = board[y][x];
        if (tile) {
          // Precise tile positioning
          const xPercent = x * 25; 
          const yPercent = y * 25;
          
          tiles.push(
            <div 
              key={tile.id} 
              className="absolute"
              style={{
                width: 'calc(25% - 6px)',
                height: 'calc(25% - 6px)',
                left: `calc(${xPercent}% + 3px)`,
                top: `calc(${yPercent}% + 3px)`,
                transition: 'all 100ms ease'
              }}
            >
              <Tile tile={tile} />
            </div>
          );
        }
      }
    }
    
    return tiles;
  };

  return (
    <div 
      className="relative bg-[#bbada0] rounded-lg p-2 md:p-3 shadow-lg"
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      tabIndex={0}
    >
      {/* Game board grid */}
      <div className="grid grid-cols-4 gap-2 md:gap-3 w-[280px] md:w-[340px] h-[280px] md:h-[340px]">
        {renderGridCells()}
      </div>
      
      {/* Tiles layer */}
      <div className="absolute inset-2 md:inset-3">
        {renderTiles()}
      </div>
    </div>
  );
}